import type { FaireProductEntity } from "../../entity_types/product";

export const p_hg4st9f9gc: FaireProductEntity = {
  token: "p_hg4st9f9gc",
  type: "product",
  name: "MORE TO COME - Animal Print Thong Mule, Wedge Heel",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/11e3e6b65aa9a985c89d13cfccd0bfb331f408034984c3c07a9a9344a9d787e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6cae7386625838fae9718e35389a6d4896673f66d30f5fd8bc97509d3f1cfd3.jpeg",
    "https://cdn.faire.com/fastly/43757c89bf5b47af18a48c0307603926ba127b37137a6429e313981fe8decef5.jpeg",
  ],
  priceDollars: 13.5,
  description:
    "Make every step a statement with these bold slip-on sandals featuring plush faux fur or eye-catching printed uppers. Designed with a chic knotted strap and effortless slide silhouette, this style combines playful textures with all-day comfort. Whether you choose luxe animal-inspired faux fur or striking zebra print, these sandals add instant personality to any outfit.\nOOTD\nPair them with relaxed linen pants and a fitted tank for an elevated vacation look, or style them with denim shorts and an oversized button-down for effortless weekend vibes. They also pair perfectly with satin slip dresses, matching lounge sets, or wide-leg trousers when you want your shoes to be the star of the outfit.",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:09.695Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
